import classcat from "classcat";
import React from "react";

import { Select } from "@touchtech/baselayer-ui";
import { Label, TextInput } from "@touchtech/web-baselayer-ui";

import css from "./PhoneInput.module.css";
import useManagePhoneInput from "./hooks/useManagePhoneInput";

type Props = {
  label?: string;
  error?: boolean;
  disabled?: boolean;
  required?: boolean;
  sizing?: "sm" | "base" | "lg" | "xl" | "2xl";
  width?: "full" | "auto";
  value: string;
  onChange?: (value: string) => void;
  onChanged?: () => void;
};

function PhoneInput({
  label,
  error,
  disabled,
  required,
  sizing = "base",
  width,
  value,
  onChange,
  onChanged,
}: Props) {
  const {
    textInputRef,
    phoneNumber,
    phoneNumberValue,
    phoneCodeOptions,
    handleCodeChange,
    handleNumberChange,
  } = useManagePhoneInput({
    value,
    onChange,
  });

  return (
    <div className={css.container}>
      {label && (
        <div className={classcat(["text-label-xs", css.label])}>
          <Label error={error} disabled={disabled} required={required}>
            {label}
          </Label>
        </div>
      )}
      <div
        className={classcat([css.selectInputContainer, { [css.error]: error }])}
      >
        <Select
          className={classcat([css.select, { [css.base]: sizing === "base" }])}
          width="78px"
          onChange={handleCodeChange}
          placeholder=""
          options={phoneCodeOptions}
          size="medium"
          defaultValue={[phoneNumber?.code as string]}
          showSearch
        />
        <TextInput
          innerRef={textInputRef}
          className={css.input}
          width={width}
          sizing={sizing}
          value={phoneNumberValue}
          onChange={handleNumberChange}
          onBlur={onChanged}
          autoComplete="new-password"
        />
      </div>
      {error && <div>{error}</div>}
    </div>
  );
}

export default PhoneInput;
